import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardProps } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(4),
    },
}));

export const CardWithClearing: React.FunctionComponent<CardProps> = props => {
    const classes = useStyles();

    return (
        <Card className={clsx(classes.root, props.className)} {...props} />
    );
};
